import * as CONST from '../ActionTypes';

const initialState = {
  successCount: null,
  failureCount: null,
  errorList: null,
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    search: '',
  },
};

function payment(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // CSVアップロード
    // -----------------
    case CONST.UPLOAD_CSV_PAYMENT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || '',
        },
      );
    case CONST.UPLOAD_CSV_PAYMENT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || action.payload,
        },
      );
    // -----------------
    // CSVアップロード
    // -----------------
    case CONST.UPLOAD_TRANSFER_ACCOUNT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || action.payload,
        },
      );
    case CONST.UPLOAD_TRANSFER_ACCOUNT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || action.payload,
        },
      );
    // -----------------
    // 口座振替結果更新
    // -----------------
    case CONST.UPDATE_TRANSFER_RESULT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || action.payload,
        },
      );
    case CONST.UPDATE_TRANSFER_RESULT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_UPLOAD_CSV_PAYMENT_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          successCount: action.payload.success_count,
          failureCount: action.payload.failure_count,
          errorList: action.payload.error_list || action.payload,
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_PROCESSING_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: action.payload,
        },
      );
    default:
      return state;
  }
}

export default payment;
